// Config
import userConstants from '@constants/userConstants';

export const shouldSetPreferredDeliveryChoice = (fulfilmentChoice: string) => () => {
  const fulfilmentChoiceIsDelivery = fulfilmentChoice === userConstants.FULFILMENT_PREFERENCE_DELIVERY;

  return fulfilmentChoiceIsDelivery;
};
